import PropTypes from "prop-types";
import FaqNav from "app/pages/Faq/FaqNav/FaqNav";
import "./FaqAsideNav.scss";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { FormattedMessage } from "react-intl";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import { HomeStrokeIcon, CrossIcon } from "app/icons/navigation";

const FaqAsideNav = ({ faqCategories, hideSidePanel = () => {} }) => {
	return (
		<div className="faq-aside-nav" onClick={hideSidePanel}>
			<div className="faq-aside-nav__header">
				<div className="faq-aside-nav__logo">
					<RelativeLink to={{ pathname: "/faq" }} data-testid="header-back-link">
						<LogoBrandContainer />
					</RelativeLink>
				</div>
				<div className="faq-aside-nav__close">
					<CrossIcon onClick={hideSidePanel} />
				</div>
			</div>
			<div className="faq-aside-nav__body">
				<div className="faq-aside-nav__home">
					<RelativeLink
						to={{
							pathname: `/faq`,
						}}
					>
						<HomeStrokeIcon height={20} width={20} style={{ marginRight: "10px" }} />
						<FormattedMessage id="faq.breadcrumb.home" />
					</RelativeLink>
				</div>
				<FaqNav faqCategories={faqCategories} />
			</div>
		</div>
	);
};

FaqAsideNav.propTypes = {
	faqCategories: PropTypes.array,
	hideSidePanel: PropTypes.func,
};

export default FaqAsideNav;
